import React from 'react';
import Form from 'react-bootstrap/Form';
import { useForceUpdate, isValidURL } from '../util';
import { FormValidityProvider, FormValidityReporter } from '../FormValidity';
import { TabContextReporter } from '../TabContext';
import TaskSlider from '@bittnerdevelopmentgroup/interactive/dist/TaskSlider/TaskSlider';
import NeutralToggle from '../controls/NeutralToggle';
export default function VideoPlayer(props) {
  var _dataProps$style, _dataProps$style2, _dataProps$style3;
  const forceUpdate = useForceUpdate();
  const dataProps = props.data.props;
  return /*#__PURE__*/React.createElement(TabContextReporter, {
    index: "0",
    title: "Video Details"
  }, /*#__PURE__*/React.createElement(FormValidityProvider, {
    onChange: props.onValidityChwange
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Video Source:"), " ", /*#__PURE__*/React.createElement("i", null, "A direct link to the audio file.")), /*#__PURE__*/React.createElement(Form.Control, {
    as: "textarea",
    value: dataProps.src,
    onChange: e => {
      dataProps.src = e.target.value;
      forceUpdate();
      props.onChanged();
    }
  }), /*#__PURE__*/React.createElement(FormValidityReporter, {
    valid: isValidURL(dataProps.src)
  }, "Please enter a valid URL.")), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Subtitle Source:"), " ", /*#__PURE__*/React.createElement("i", null, "A direct link to the captions file.")), /*#__PURE__*/React.createElement(Form.Control, {
    as: "textarea",
    value: dataProps.trackSource,
    onChange: e => {
      dataProps.trackSource = e.target.value;
      forceUpdate();
      props.onChanged();
    }
  }), /*#__PURE__*/React.createElement(FormValidityReporter, {
    valid: isValidURL(dataProps.trackSource)
  }, "Please enter a valid URL.")), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Width Percentage:")), /*#__PURE__*/React.createElement(TaskSlider, {
    handleChange: value => {
      dataProps.style.width = `${value}%`;
      forceUpdate();
      props.onChanged();
    },
    start: ((_dataProps$style = dataProps.style) === null || _dataProps$style === void 0 ? void 0 : _dataProps$style.width) === undefined ? 100 : parseInt((_dataProps$style2 = dataProps.style) === null || _dataProps$style2 === void 0 ? void 0 : _dataProps$style2.width),
    min: 33,
    max: 100,
    step: 1,
    tooltip: "auto"
  })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Center Align:")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(NeutralToggle, {
    optionTrue: "Yes",
    optionFalse: "No",
    value: ((_dataProps$style3 = dataProps.style) === null || _dataProps$style3 === void 0 ? void 0 : _dataProps$style3.margin) === "auto",
    onChange: v => {
      dataProps.style.margin = v ? "auto" : undefined;
      forceUpdate();
      props.onChanged();
    }
  }))))));
}